import {
  CreateAccount,
  GameLibrary,
  GamesList,
  NeedVerification,
  OrderSuccess,
  GiftCardsDetails,
  GiftCardsList,
  UserSettings,
  VerificationResult,
  GameDetails,
  AccountBalance,
  BlockedAccount,
  Authorization,
  NotAvailable,
  SecondEmailConnect,
  ReferralLanding,
  GrabInformation,
  AuthErrorPage,
  SelectCountry,
  QuestsList,
  CountryErrorPage,
  CameraNotAllowed,
  AppUsagePermission,
  Admin,
  OfferTools,
  AcceptTOSPrompt,
  Friends,
} from './pages'
import LogoutPage from './pages/LogoutPage/LogoutPage'
import PlatformSelect from './pages/PlatformSelect/PlatformSelect'

export const NOT_AUTHORIZED_ROUTES = [
  { path: '/initiate-auth', Component: GrabInformation },
  { path: '/auth/v2', Component: CreateAccount },
  { path: '/auth', Component: CreateAccount },
  { path: '/oauth', Component: CreateAccount },
  { path: '/two-step-create-account', Component: CreateAccount },
  { path: '/sign-up', Component: Authorization },
  { path: '/auth-error', Component: AuthErrorPage },
  { path: '/country-error', Component: CountryErrorPage },
  { path: '/referral/:referralId', Component: ReferralLanding },
  { path: '/referral', Component: ReferralLanding },
  { path: '/blocked', Component: BlockedAccount },
]

export const PUBLIC_ROUTES = [
  { path: '/not-available', Component: NotAvailable },
  { path: '/logout', Component: LogoutPage },
  { path: '/platform-select', Component: PlatformSelect },
]

export const PROTECTED_ROUTES = [
  { path: '/rewards', Component: GiftCardsList },
  { path: '/select-country', Component: SelectCountry },
  { path: '/rewards/:giftCardId/:denomination', Component: GiftCardsDetails },
  { path: '/games', Component: GamesList },
  { path: '/games/:unifiedAppId', Component: GameDetails },
  { path: '/quests', Component: QuestsList },
  { path: '/library', Component: GameLibrary },
  { path: '/friends', Component: Friends },
  { path: '/verification', Component: NeedVerification },
  { path: '/verification/result', Component: VerificationResult },
  { path: '/verification/camera-access', Component: CameraNotAllowed },
  { path: '/order/:orderId/success', Component: OrderSuccess },
  { path: '/profile/settings', Component: UserSettings },
  { path: '/profile/balance', Component: AccountBalance },
  { path: '/second-email/:dataId', Component: SecondEmailConnect },
  { path: '/app-usage-permission', Component: AppUsagePermission },
  { path: '/accept-tos', Component: AcceptTOSPrompt },
]

export const ADMIN_ROUTES = [
  { path: '/admin', Component: Admin },
  { path: '/admin/offer-tools', Component: OfferTools },
]
